module.exports = __webpack_public_path__ + "static/media/hubpic12.2ba22d38.jpg";